export default "/mobile-preview.f450fa92-2d0311.png";